import React, { Component } from 'react';
import { translate } from '../Services/translation';

import RadioOnIcon from '../../icons/radio-on.svg';
import RadioOffIcon from '../../icons/radio-off.svg';
import ChevronDownIcon from '../../icons/chevron-down.svg';
import CloseOvalIcon from '../../icons/close-oval.svg';
class FilterOption extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
        };

        this.toggleShowMore = this.toggleShowMore.bind(this);          
    }

    toggleShowMore(event) {
        event.preventDefault();
        this.setState({
            collapsed: !this.state.collapsed,
        });

    }
    render() {
        let selectedOptionPrice = 0;
        if (this.props.selectedOptionPrice) {
            selectedOptionPrice = this.props.selectedOptionPrice;
        }      
        const { item, group, searchFacetChange } = this.props;
        const isSelected = group.selectedOptions !== null && group.selectedOptions.includes(item.id);
        const extraFields = item.productItem;
        const isEnabled = item.quantity > 0 || group.selectedOptions.includes(item.id);

        if (extraFields) {
            let displayName;
            let displayDescription;
            let priceVat;
            const specificationFields = extraFields.specifications;
            const currency = extraFields.currency.symbol;
            
            if (group.id === 'color') {
                displayName = extraFields.colorDisplayName;
                displayDescription = extraFields.colorDescription;

            } else if (group.id === 'drive') {
                displayName = extraFields.driveName;
                displayDescription = extraFields.driveDescription;

            } else if (group.id === 'package') {
                displayName = extraFields.packageName;
                displayDescription = extraFields.packageDescription;

            } else if (group.id === 'transmission') {
                displayName = extraFields.transmissionName;
                displayDescription = extraFields.transmissionDescription;

            } else if (group.id === 'engine') {
                displayName = extraFields.engineName;
                displayDescription = extraFields.engineDescription;
                
            }
            if (extraFields.price && extraFields.price.price) {
                const priceDiff = extraFields.price.price.priceWithVat - selectedOptionPrice;
                priceVat = (priceDiff >= 0 ? '+' : '-') + Math.abs(priceDiff);
            }
            else {
                priceVat = "-"
            }

            return (
                <div className={`faceted-filter-wrapper ${!isEnabled ? 'faceted-filter-wrapper--disabled': ''}`}>
                    <label className={`faceted-filter ${isSelected
                        ? 'faceted-filter--selected'
                        : ''
                        }`}>
                        <div className="faceted-filter-input-wrapper">
                            <input className="faceted-filter__input" type="checkbox"
                                onChange={(event) => 
                                    !isSelected ? searchFacetChange(group, item)
                                    : event.stopPropagation()
                                }
                                checked={isSelected}
                                disabled={!isEnabled}
                            />
                            {
                            isEnabled ?
                                <div className="faceted-filter__label">
                                    { isSelected ?
                                        <RadioOnIcon className="icon" />
                                        :
                                        <RadioOffIcon className="icon" />
                                    }
                                    <div className="faceted-filter-quantity-and-price">
                                            <span className="faceted-filter__quantity">
                                        {displayName}
                                                </span>
                                        <span className="faceted-filter__price">
                                            {priceVat} {currency}
                                        </span>
                                    </div>
                                </div>
                                : 
                                <div className="faceted-filter__label">
                                    <CloseOvalIcon className="icon" />
                                    <div className="faceted-filter-quantity-and-price">
                                            <span className="faceted-filter__quantity">
                                        {displayName}
                                                </span>
                                        <span className="faceted-filter__price">
                                            {priceVat} {currency}
                                        </span>
                                    </div>
                                </div>
                            }
                            <div className="faceted-filter__show-more">
                                <a className={`faceted-filter__show-more-text ${!this.state.collapsed ? 'faceted-filter__show-more-text--open'
                                        : ''
                                    }`}
                                 onClick={ (event) => this.toggleShowMore(event)}
                                >
                                    <span>{!this.state.collapsed ? translate('product.showless') : translate('product.showmore')}</span>
                                    <span>
                                        <ChevronDownIcon className={`faceted-filter__show-more-icon icon ${!this.state.collapsed ? 
                                        'faceted-filter__show-more-icon--open icon'
                                        : 
                                        ''
                                        }`}
                                        />
                                    </span>
                                </a>
                            </div>
                            <p className={`faceted-filter__description--mobile-only ${!this.state.collapsed ? 'faceted-filter__description--mobile-only--show': ''
                                    }`} dangerouslySetInnerHTML={{ __html: displayDescription }}>
                        </p>
                        </div>

                        <div
                            className={`faceted-filter__divider-line ${
                                isSelected
                                    ? 'faceted-filter__divider-line--selected'
                                    : ''
                                }`}
                        ></div>
                        <p className={`faceted-filter__description show-for-large ${this.state.collapsed ? '' : 'faceted-filter__description--expanded show-for-large'}`} dangerouslySetInnerHTML={{ __html: displayDescription }}>
                        </p>
                    </label>
                    {specificationFields &&
                        <ul className={`faceted-filter__show-more-options ${!this.state.collapsed ? 'faceted-filter__show-more-options--open' : ''}`}>
                            {specificationFields.map((field) =>
                                <li key={field.id}><strong>{field.header}</strong>
                                    {field.value}
                                </li>
                            )}
                        </ul>
                    }
                </div>
            );
        } else {
            return (
                <div className="faceted-filter faceted-filter-error">
                    <strong>Unable to read: {item.id}</strong>
                </div>
            )
        }
    }
}

export default FilterOption;
